/**
 * index.js
 *
 * @Author: wangyinan
 * @Date: 2017/7/12 下午6:26
 */

import Tabs from './Tabs';
import Tab from './Tab';

Tabs.Tab = Tab;
export { Tab };
export default Tabs;



// WEBPACK FOOTER //
// ./src/tabs/index.js